// apps/web/src/App.tsx
import { RouterProvider } from 'react-router-dom'
import { router } from './router'
import { Toaster, TooltipProvider } from '@viecxanh/chat-ui'

export default function App() {
  return (
    <TooltipProvider>
      <RouterProvider router={router} />
      <Toaster />
    </TooltipProvider>
  )
}
